import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/ReferencesPage.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface BeforeAfterImage {
  id: number;
  before: string;
  after: string;  
}

const SAMPLE_IMAGES: BeforeAfterImage[] = [
  {
    id: 1,
    before: '/images/references/before-1.png',
    after: '/images/references/after-1.png',    
  },
  {
    id: 2,
    before: '/images/references/before-2.png',
    after: '/images/references/after-2.png',    
  },
  {
    id: 3,
    before: '/images/references/before-3.png',
    after: '/images/references/after-3.png',    
  },
  {
    id: 4,
    before: '/images/references/before-4.png',
    after: '/images/references/after-4.png',    
  },
  {
    id: 5,
    before: '/images/references/before-5.png',
    after:  '/images/references/after-5.png',    
  },
  {
    id: 7,
    before: '/images/references/before-7.png',
      after: '/images/references/after-7.png',
  },
  {
    id: 8,
    before: '/images/references/before-8.png',
    after: '/images/references/after-8.png',
  },
  {
    id: 9,
    before: '/images/references/before-9.png',
    after: '/images/references/after-9.png',
  },
  {
    id: 10,
    before: '/images/references/before-10.png',
    after: '/images/references/after-10.png',
  },
  {
    id: 11,
    before: '/images/references/before-11.png',
    after: '/images/references/after-11.png',
  },  
  {
    id: 12,
    before: '/images/references/before-12.png',
    after: '/images/references/after-12.jpeg',
  },
  {
    id: 13,
    before: '/images/references/before-13.png',
    after: '/images/references/after-13.png',
  },
  {
    id: 14,
    before: '/images/references/before-14.png',
    after: '/images/references/after-14.png',
  },  
  {
    id: 15,
    before: '/images/references/before-15.png',
    after: '/images/references/after-15.png',
  },  
  {
    id: 16,
    before: '/images/references/before-16.png',
    after: '/images/references/after-16.png',
  },    
  {
    id: 17,
    before: '/images/references/before-17.png',
    after: '/images/references/after-17.png',
  },    
  {
    id: 18,
    before: '/images/references/before-18.png',
    after: '/images/references/after-18.png',
  },      
  {
    id: 19,
    before: '/images/references/before-19.png',
    after: '/images/references/after-19.png',
  },    
  {
    id: 20,
    before: '/images/references/before-20.png',
    after: '/images/references/after-20.png',
  },      
  {
    id: 21,
    before: '/images/references/before-21.png',
    after: '/images/references/after-21.png',
  },    
  {
    id: 22,
    before: '/images/references/before-22.png',
    after: '/images/references/after-22.png',
  },    
];

const ReferencesPage: React.FC = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>Referenciák | Pelyák Adél</title>
        <meta name="description" content="Tekintse meg pedikűr és manikűr munkáim előtte-utána képeit. Professzionális körömátalakítások és kezelések referenciái." />
        <meta name="keywords" content="pedikűr referenciák, manikűr referenciák, körömápolás előtte-utána, lábápolás referenciák" />
        <meta property="og:title" content="Referenciák | Pelyák Adél" />
        <meta property="og:description" content="Tekintse meg pedikűr és manikűr munkáim előtte-utána képeit. Professzionális körömátalakítások és kezelések referenciái." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <main className="references-container">
        <h1>Referenciák</h1>
        <p className="references-intro">
          Böngéssz körömátalakításaim galériájában.
        </p>
        <Slider {...sliderSettings} className="references-carousel">
          {SAMPLE_IMAGES.map((item) => (
            <div className="before-after-container" key={item.id}>
              <div className="image-comparison">
                <div className="image-wrapper">
                  <h4>Előtte</h4>
                  <img src={item.before} alt="Before" />
                </div>
                <div className="image-wrapper">
                  <h4>Utána</h4>
                  <img src={item.after} alt="After" />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </main>
      <Footer />
    </>
  );
};

export default ReferencesPage; 